import { useEffect, useState } from "react";
import type { TimecodeBasis } from "../lib/pickupContext";

const KEY = "mb.tc.basis";

/**
 * Persisted choice of timecode basis for the Pickups Package — "Chapter" (from
 * each chapter's start) or "Book" (running time from the start of the audiobook).
 * Shared across the owner + public views via localStorage.
 */
export function useTimecodeBasis(): [TimecodeBasis, (b: TimecodeBasis) => void] {
  const [basis, setBasis] = useState<TimecodeBasis>(() => {
    const v = typeof localStorage !== "undefined" ? localStorage.getItem(KEY) : null;
    return v === "book" ? "book" : "chapter";
  });
  useEffect(() => {
    try { localStorage.setItem(KEY, basis); } catch { /* storage blocked */ }
  }, [basis]);
  return [basis, setBasis];
}

export function TimecodeToggle({
  value,
  onChange,
}: {
  value: TimecodeBasis;
  onChange: (b: TimecodeBasis) => void;
}) {
  return (
    <div className="tc-toggle" role="group" aria-label="Timecode basis">
      <span className="tc-toggle-label">Timecodes</span>
      <div className="tc-seg">
        <button
          className={`tc-opt${value === "chapter" ? " on" : ""}`}
          onClick={() => onChange("chapter")}
          title="From the start of each chapter"
        >
          Chapter
        </button>
        <button
          className={`tc-opt${value === "book" ? " on" : ""}`}
          onClick={() => onChange("book")}
          title="From the start of the whole audiobook"
        >
          Book
        </button>
      </div>
    </div>
  );
}
